import styled from "styled-components";

const Lead = styled.p`
  font-size: 18px;
  margin-bottom: ${(props) => props.xl && "40px"};
`;

export default Lead;
